export default "__VITE_ASSET__38196b76__"